import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { isMobile } from "react-device-detect"

export default class LinkButtonsBanner extends Component {
  renderButtons = (buttons) => {
    if (buttons && buttons.length > 0) {
      return buttons.map((button, index) => {
        const icon = SelectionFactoryHelper.getFromSelectionFactory(button.icon)
        const iconUpload = button.iconUpload
        const color = SelectionFactoryHelper.getFromSelectionFactory(button.buttonColor)
        return (
          <a key={index} href={button.link}>
            <button className={`button button--large button--general ${color ? color : ""}`}>
              {iconUpload ? <img className={"icon"} src={iconUpload} alt="" /> : <Svg iconName={icon} fillColor={"#FFF"} />}
              <span className="text" dangerouslySetInnerHTML={{ __html: button.richText }}></span>
            </button>
          </a>
        )
      })
    }
  }

  render() {
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.backgroundColor)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonColor)

    return (
      <div className={`guide-block-covid ${backgroundColor ? backgroundColor : ""}`}>
        <div className="w--wider">
          <div className="grid">
            {isMobile || !this.props.textAlignRight ? (
              <React.Fragment>
                <div className="guide-block-covid__right grid-item col--12 col-sm--6">
                  <div className="guide-block-covid__header">{this.props.headline}</div>
                  <div className="guide-block-covid__info" dangerouslySetInnerHTML={{ __html: this.props.richText }}></div>
                  <div className="cta-button desktop">
                    <a
                      href={this.props.buttonLink ? this.props.buttonLink : undefined}
                      className={`button button--medium button--discreet ${buttonColor ? buttonColor : ""}`}
                    >
                      {this.props.buttonText}
                    </a>
                  </div>
                </div>
                <div className="guide-block-covid__left grid-item col--12 col-sm--6">
                  <div className="guide-block-covid__links">{this.renderButtons(this.props.buttons)}</div>
                  <div className="cta-button mobile">
                    <a
                      href={this.props.buttonLink ? this.props.buttonLink : undefined}
                      className={`button button--medium button--discreet ${buttonColor ? buttonColor : ""}`}
                    >
                      {this.props.buttonText}
                    </a>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className={`guide-block-covid__left grid-item col--12 col-sm--6`}>
                  <div className="guide-block-covid__links">{this.renderButtons(this.props.buttons)}</div>
                  <div className="cta-button mobile">
                    <a
                      href={this.props.buttonLink ? this.props.buttonLink : undefined}
                      className={`button button--medium button--discreet ${buttonColor ? buttonColor : ""}`}
                    >
                      {this.props.buttonText}
                    </a>
                  </div>
                </div>
                <div className="guide-block-covid__right grid-item col--12 col-sm--6 align-right">
                  <div className="guide-block-covid__header">{this.props.headline}</div>
                  <div className="guide-block-covid__info" dangerouslySetInnerHTML={{ __html: this.props.richText }}></div>
                  <div className={`cta-button desktop`}>
                    <a
                      href={this.props.buttonLink ? this.props.buttonLink : undefined}
                      className={`button button--medium button--discreet ${buttonColor ? buttonColor : ""}`}
                    >
                      {this.props.buttonText}
                    </a>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    )
  }
}
